import styled from 'styled-components'

type Props = {
	isChecked: boolean
}

export const Radio = styled.div<Props>`
	width: 20px;
	height: 20px;
	border-radius: 50%;
	border: 2px solid ${({ theme }) => theme.color.primary};
	box-sizing: border-box;
	position: relative;

	&:after {
		content: '';
		width: 12px;
		height: 12px;
		border-radius: 50%;
		position: absolute;
		top: 2px;
		left: 2px;
		background-color: ${({ theme, isChecked }) => (isChecked ? theme.color.primary : 'transparent')};
		transition: background-color 0.15s ease-in-out;
	}
`
